import React, { useEffect, useState } from "react";
import { Linkedin } from "lucide-react";
import { fetchTalent } from "../lib/api";
import { Icon } from "./shared";

export default function Talent() {
  const [members, setMembers] = useState([]);

  useEffect(() => {
    fetchTalent().then(setMembers).catch(() => setMembers([]));
  }, []);

  return (
    <section id="talent" className="nst-navy text-white py-24 lg:py-32 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-25" />
      <div className="glow-orb w-[500px] h-[500px] top-20 right-0" style={{ background: "#2E6BF6" }} />

      <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <span className="pill-label on-dark">Our Talent</span>
            <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05]">
              Principal-Level <br />
              <span className="text-[#6B9FFF]">Engineering Talent</span>
            </h2>
          </div>
          <p className="text-white/70 text-base lg:text-lg max-w-md">
            Work directly with experienced engineers who design and deliver enterprise-scale systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {members.map((t) => (
            <div
              key={t.slug}
              className="relative bg-white/[0.04] border border-white/10 rounded-3xl p-8 backdrop-blur-sm card-lift hover:border-[#2E6BF6]/60 hover:bg-white/[0.08]"
            >
              <div className="w-14 h-14 rounded-2xl bg-[#2E6BF6]/15 border border-[#2E6BF6]/30 flex items-center justify-center mb-7">
                <Icon name={t.icon} className="w-6 h-6 text-[#6B9FFF]" />
              </div>
              <h3 className="text-2xl font-extrabold">{t.role}</h3>
              <p className="mt-3 text-white/70 leading-relaxed">{t.description}</p>
              <div className="mt-6 pt-6 border-t border-white/10">
                <div className="text-[11px] uppercase tracking-wider text-white/50 font-semibold mb-1">Focus</div>
                <div className="text-sm text-white/90">{t.focus}</div>
              </div>
              <div className="mt-6 flex items-center gap-2 text-[#6B9FFF] text-sm font-semibold">
                <Linkedin className="w-4 h-4" /> Connect on LinkedIn
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
